// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1286":"7a89905e","8173":"8ef2e6dd","8905":"7a89905e"}[chunkId] + ".chunk.css";
};